module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "DED-TOP",
    attrs: {
      "id": "ded"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "v",
      "id": "pg_v",
      "role": "doc-pagebreak"
    }
  }, [_c('b', [_c('i', [_vm._v("This book is dedicated")])])])]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("to those who loved "), _c('i', [_vm._v("Abandoned Breaths")])]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("enough to let the words breathe,")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("and to everyone who fights the stigma")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("of heartache. You are not weak")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("because you feel.")]), _vm._v(" "), _c('p', {
    staticClass: "HALF-SPACE1"
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("You are the strongest souls I know.")]), _vm._v(" "), _c('p', {
    staticClass: "HALF-SPACE1"
  }), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("Everyone becomes a poet when their")]), _vm._v(" "), _c('p', {
    staticClass: "DED"
  }, [_vm._v("hearts are screaming.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c5fffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 66
// module chunks = 0